import React from 'react';
import { useConstructorStore } from '../store/constructorStore';
import { t } from '../i18n';

export const Step1Info: React.FC = () => {
  const {
    business_name, business_description, phone, whatsapp, instagram,
    address, work_hours, language, setField,
  } = useConstructorStore();

  const inputStyle: React.CSSProperties = {
    width: '100%', padding: '12px 14px', border: '1px solid #ddd',
    borderRadius: 10, fontSize: 16, outline: 'none',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 6, color: '#555',
  };

  const groupStyle: React.CSSProperties = { marginBottom: 16 };

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>{t('step1_title', language)}</h2>

      <div style={groupStyle}>
        <label style={labelStyle}>{t('business_name', language)}</label>
        <input style={inputStyle} value={business_name}
          onChange={(e) => setField('business_name', e.target.value)}
          placeholder={t('business_name_placeholder', language)} />
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t('business_description', language)}</label>
        <textarea style={{ ...inputStyle, minHeight: 80, resize: 'vertical' }} value={business_description}
          onChange={(e) => setField('business_description', e.target.value)}
          placeholder={t('business_description_placeholder', language)} />
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t('phone', language)}</label>
        <input style={inputStyle} value={phone} onChange={(e) => setField('phone', e.target.value)}
          placeholder={t('phone_placeholder', language)} type="tel" />
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t('whatsapp', language)}</label>
        <input style={inputStyle} value={whatsapp} onChange={(e) => setField('whatsapp', e.target.value)}
          placeholder={t('whatsapp_placeholder', language)} />
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t('instagram', language)}</label>
        <input style={inputStyle} value={instagram} onChange={(e) => setField('instagram', e.target.value)}
          placeholder={t('instagram_placeholder', language)} />
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t('address', language)}</label>
        <input style={inputStyle} value={address} onChange={(e) => setField('address', e.target.value)}
          placeholder={t('address_placeholder', language)} />
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t('work_hours', language)}</label>
        <input style={inputStyle} value={work_hours} onChange={(e) => setField('work_hours', e.target.value)}
          placeholder={t('work_hours_placeholder', language)} />
      </div>
    </div>
  );
};
